const OpenFolderIcon = () => {
  return (
    <svg
      width="30"
      height="26"
      viewBox="0 0 30 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.18446 0.161621H5.21571H3.87068L2.47969 0.996572L1.69071 2.01707L0.94873 3.13034V5.77435V13.5209V22.0559L1.69071 23.4011L3.87068 25.0246H25.9041L28.1771 23.7258L29.0584 22.0559V13.1498V8.09367L28.1771 5.44965L26.368 4.33638H22.5643H16.2094L13.2407 3.40866L11.5244 1.41405L8.18446 0.161621Z"
        fill="#77778C"
      />
    </svg>
  );
};

export default OpenFolderIcon;
